import { render } from "./Login.vue?vue&type=template&id=82c270ce"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=82c270ce&lang=css"
script.render = render

export default script